import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/app/node_modules/.pnpm/@chakra-ui+react@3.37.0_@emotion+react@11.14.0_@types+react@19.3.0_react@18.3.1__react-dom@18_p3u6zxitce3om6yegscvkjxpoe/node_modules/@chakra-ui/react/dist/esm/components/box/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/_components/Map/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/profile/_components/Profile/index.tsx");
